import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import QuoteFormModal from './QuoteFormModal';

export default function QuoteFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/quotes');
  };

  const handleSuccess = () => {
    history.push('/quotes');
  };

  return (
    <AdminLayout title={id ? 'Edit Quote' : 'Add Quote'}>
      <QuoteFormModal
        open={true}
        quoteId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}